var _defs, _rect, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _rect3, _path0, _g, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polyline, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g3, _circle, _circle2, _circle3, _circle4, _line, _path34, _path35, _path36, _path37, _path38, _line2, _rect4, _rect5, _path39, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _path40, _path41, _path42, _polyline2, _line11, _line12, _line13, _line14, _circle5, _polygon, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodcastplanningproduction6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-18,.cls-20,.cls-22,.cls-23,.cls-24,.cls-25,.cls-27,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-5{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-3,.cls-4{fill:#2f2143;}.cls-5{stroke:#364e54;}.cls-15,.cls-18,.cls-20,.cls-22,.cls-23,.cls-24,.cls-25,.cls-27,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-5{stroke-miterlimit:10;}.cls-18,.cls-5{stroke-width:1.08px;}.cls-6{fill:#21525e;}.cls-7{fill:#364e54;}.cls-8{fill:#544741;}.cls-9{clip-path:url(#clip-path);}.cls-10{fill:#c7b299;}.cls-11{clip-path:url(#clip-path-2);}.cls-12{fill:#5e443c;}.cls-13{fill:#fabba2;}.cls-14{fill:#9a499c;}.cls-15{stroke:#ffc20e;stroke-width:0.27px;}.cls-16{fill:#192f34;}.cls-17{fill:#fff;}.cls-18{stroke:#544741;}.cls-19{fill:#ffc20e;}.cls-20{stroke:#002f3e;stroke-width:3.24px;}.cls-21{opacity:0.6;}.cls-22,.cls-23,.cls-24,.cls-25,.cls-27,.cls-29,.cls-30,.cls-31{stroke:#662d91;}.cls-23,.cls-29{stroke-width:0.73px;}.cls-24{stroke-width:2px;}.cls-25{stroke-width:1.46px;}.cls-26{fill:#386994;}.cls-27{stroke-width:0.83px;}.cls-28{fill:#2e1f42;}.cls-29,.cls-30{stroke-linecap:round;}.cls-30{stroke-width:0.64px;}.cls-31{stroke-width:2.36px;}.cls-32,.cls-33{stroke:#2f2143;}.cls-32{stroke-width:1.27px;}.cls-33{stroke-width:1.31px;}.cls-34{stroke:#2e1f42;stroke-width:1.35px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.42,278.6a30.17,30.17,0,0,0-1.61,15,20.38,20.38,0,0,0,2.62.72,23.4,23.4,0,0,0,7.08.32c4.66-.27,10.21,2.25,13.44,6a16.14,16.14,0,0,1,3.71,9H142.17l4.53-31.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.43,275.76a30.1,30.1,0,0,0,5.46,6.41,23,23,0,0,0,2.46-1.14,23.76,23.76,0,0,0,5.63-4.31c3.39-3.21,9.27-4.85,14.13-4.07a16.13,16.13,0,0,1,8.63,4.49l-35.58,29.92-16.53-26.69,12.8-10.76a30.51,30.51,0,0,0,3,6.15"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "podcast planning &amp;amp; production6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(440.09 157.77)"
  }, "PODCAST PLANNING", /*#__PURE__*/React.createElement("tspan", {
    x: 90.25,
    y: 73
  }, "&amp; PRODUCTION"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.25,314.81h58.06a10.3,10.3,0,0,0-10.3-10.3H307.55A10.3,10.3,0,0,0,297.25,314.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269,113.49s18.49,3.8,17,21.69c0,0-3.63,30.34,16.51,20.69,0,0,10.43-6.68,14.4-5.65,0,0,11.39,3.81,9.07,10.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.47,115.23l-3.11-1.1a2.35,2.35,0,0,1,1.58-4.42l3.1,1.1a2.35,2.35,0,1,1-1.57,4.42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.53,111.15l23,5.87a2.6,2.6,0,0,0,2,0,2.52,2.52,0,0,0,1.17-1.29c.69-1.42,1.94-4.44,3.45-8.44a2.56,2.56,0,0,0-.23-2,2.83,2.83,0,0,0-2-1.21L244,93.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.25,111.64l6.43-17.83L235,90.17a9.52,9.52,0,0,0-10,4.46,10.5,10.5,0,0,0-.52,8.54,9.61,9.61,0,0,0,2.85,3.8l10.93,4.67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.82,150.56h-4.43V111a2.11,2.11,0,0,1,2.11-2.11h.21a2.11,2.11,0,0,1,2.11,2.11Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M255.44,111.64a.84.84,0,0,1-1.67,0,.84.84,0,1,1,1.67,0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.94,
    y: 150.17,
    width: 15.33,
    height: 5.04
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M237.67,95.82a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M239.36,93.52a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 320.36,
    y: 163.43,
    width: 10.96,
    height: 140.86
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.66,309.66H142.17l4.53-31.06h16.72a30.17,30.17,0,0,0-1.61,15,20.38,20.38,0,0,0,2.62.72,23.4,23.4,0,0,0,7.08.32c4.66-.27,10.21,2.25,13.44,6a16.14,16.14,0,0,1,3.71,9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "142.8 305.36 172.81 305.36 179.93 296.76 195.63 296.76 192.11 310.86 139.19 312.13 142.8 305.36"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.69,308.71h0a3.8,3.8,0,0,0,4.51-2.93L96.39,220A3.8,3.8,0,0,0,89,218.44L70.76,304.21a3.81,3.81,0,0,0,2.93,4.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.05,311.05h0a3.81,3.81,0,0,0,3.8-3.8V219.57a3.8,3.8,0,0,0-7.6,0v87.68a3.81,3.81,0,0,0,3.8,3.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.11,309.59h0a3.81,3.81,0,0,0,3-4.47l-16.94-86a3.8,3.8,0,0,0-7.46,1.47l16.94,86a3.82,3.82,0,0,0,4.47,3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.74,277.14l-35.58,29.92-16.53-26.69,12.8-10.76a30.77,30.77,0,0,0,3,6.15,30.1,30.1,0,0,0,5.46,6.41,23,23,0,0,0,2.46-1.14,23.76,23.76,0,0,0,5.63-4.31c3.39-3.21,9.27-4.85,14.13-4.08a16.25,16.25,0,0,1,8.63,4.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "211.87 303.36 234.83 284.05 234.75 272.88 246.77 262.77 253.15 275.83 213.47 310.86 211.87 303.36"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.25,220.91H81.9a4.34,4.34,0,0,1,0-8.68h48.35a4.34,4.34,0,0,1,0,8.68"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.17,213.13,166,236.77l29,51.88,28.72-19.42S203,228.88,181.93,215Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.87,285.87l45.73,2.46L181.92,217a27.41,27.41,0,0,0-3.9-14.8c-4.44-7.26-11.37-10-14.87-11.35-2.25-.87-5.26-1.77-21.49-2.67-6-.34-11-.52-14.49-.62L73.42,185.2s-5,26.62,23.27,28.25l47.61,4.9Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M120,89.61s-.62-7.92.84-12.22c0,0,15.79,3.2,15.57-13.41,0,0,3.54-2.32,3.28-5.23,0,0-5.27-1.44-5.41-9.72,0,0,1.24-8.23-3.15-13.22,0,0-42.88-24-29.59,50.6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.09,99.13l-5.4,27s17.41,17.12,23,20.33c0,0,2.57,2.18,8.1,1.52l47.13-7.45L200.78,125l-43,6.36Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M183.26,89.16s3.37-2.51,4.08-4.06c0,0,2.78-3.48-2.8-1,0,0-4.43,1.27-7.7,11.13l-5.75,7.69,10.51,5.44s3.14-5.64,4.74-5.88c0,0,8.3,1.56,9.8,1.74,0,0,1.36.32,3.73-.94,0,0,3.16-1.69,2.33-2.72,0,0-.23-.76-1.85.06a4.75,4.75,0,0,1-4.85-.13s2.92.41,4.78-.73c0,0,3.44-1.75,2.74-4.46,0,0,2.88-2.29,2.43-3.49,0,0-.3-1.25-3.9,1-.23.13-2.29,1.42-3,1.35l-4.52-1.09a15.29,15.29,0,0,0,3.88-.77c1.1-.55,5.79-3.23,5.82-4.82,0,0-.14-1.77-3.75.28,0,0-2.86,1.77-3.7,1.82Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M75.11,186.11l54.13,2.38s7.81-74.66,4.43-82.82c0,0-.56-6.6-8.54-14.72l-26.8-8.47S84.71,91.13,82,113.71L70.78,175s-1.13,8.93,4.33,11.12"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M198.5,137l5.45-2.19s10.45,3.68,14.49-1.16c0,0,1-1.27-7.45-1.3a17,17,0,0,1,10.46-4.81,12.81,12.81,0,0,1,3.6,1.44s4,1.23,1.66-1.63c0,0-3.5-3.58-6.55-3.25s-20.88,4.09-20.88,4.09l-.26.06Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.92,129.49,112.5,100.9a12.42,12.42,0,0,0-5.7-2.22c-.34,0-5.89-.62-9.78,3.12s-4.59,10-1.73,15.46c0,0,18,20.48,34.21,27.48,0,0,13.59,7.88,24.08,1.24,0,0,16.88-8.14,31.23-39.46l-14-6.76S143,130.37,140.92,129.49"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M91.5,186.83s-13,23.6,71.3,23.44l-9,68.83"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M139.19,278.6c.64-.15,35.52,2.38,35.52,2.38"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M119.87,52.25c-1.57-7.36-.27-10.43,1.37-11.82,4.48-3.82,14.48,2.31,17.75-1.67a5.6,5.6,0,0,0,.77-4.46c1.19-.14,4.76-.63,5-2.12.14-.74-.6-1.45-.88-1.72-16.28-15.58-33.62-8.15-33.62-8.15A28.11,28.11,0,0,0,97.57,34.59,4.46,4.46,0,0,0,94,33.88C89.3,35.33,87.2,48.33,91.79,57.8A24.09,24.09,0,0,0,99.9,67s-3.42-12.73,3-18.19c3.78-3.2,8.73-2.49,10-2.31"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M125.27,65.52l7.8.55s-.54,6.29-3.9,5.54c0,0-3.48-.54-3.9-6.09"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "131.16 51.84 128.94 51.84 130.78 53.48"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M112.47,48.58S116.78,25.39,124.56,22c0,0-4.07-5.14-9.24-1.36,0,0-5.71,7.21-9.24,28Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M118.32,55.72a10,10,0,1,1-10-10,10,10,0,0,1,10,10"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M114.55,55.72a6.22,6.22,0,1,1-6.22-6.22,6.22,6.22,0,0,1,6.22,6.22"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M131.58,280c0,3.1-11.12,5.6-24.83,5.6s-24.84-2.5-24.84-5.6,11.12-5.6,24.84-5.6S131.58,276.94,131.58,280Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330,166.49H147.71a5.54,5.54,0,1,1,0-11.07H330a5.54,5.54,0,1,1,0,11.07"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.34,93.26a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.43,93.26a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M235,95.56a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 399.48,
    y: 230.5,
    width: 5.48,
    height: 71.96,
    rx: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 413.17,
    y: 247.06,
    width: 5.48,
    height: 55.4,
    rx: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M428.83,302.46h0a2.74,2.74,0,0,1-2.74-2.74V202.06a2.74,2.74,0,0,1,5.48,0v97.66A2.75,2.75,0,0,1,428.83,302.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 439,
    y: 272.02,
    width: 5.48,
    height: 30.44,
    rx: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 451.91,
    y: 257.62,
    width: 5.48,
    height: 44.84,
    rx: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 464.83,
    y: 240.21,
    width: 5.48,
    height: 62.25,
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 477.74,
    y: 270.53,
    width: 5.48,
    height: 31.93,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 490.65,
    y: 241.58,
    width: 5.48,
    height: 60.88,
    rx: 2.39
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 1389.27,
    cy: 182.48,
    r: 55.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1389.27,
    cy: 182.48,
    r: 77.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1389.27,
    cy: 182.48,
    r: 55.39
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1389.27,
    cy: 182.48,
    r: 100.96
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 1500.44,
    y1: 184.12,
    x2: 1582.7,
    y2: 184.12
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1582.42,189.63a5.51,5.51,0,1,0-5.5-5.51,5.51,5.51,0,0,0,5.5,5.51"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1274.56,184.12H1192.3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1192.58,178.61a5.51,5.51,0,1,0,5.5,5.51,5.51,5.51,0,0,0-5.5-5.51"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1391.58,210.45h0a18.59,18.59,0,0,1-18.53-18.53V169.76a18.53,18.53,0,1,1,37.06,0v22.16a18.59,18.59,0,0,1-18.53,18.53"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1410.11,191.92a18.53,18.53,0,1,1-37.06,0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 1391.58,
    y1: 151.23,
    x2: 1391.58,
    y2: 151.23
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1367.8,
    y: 157.65,
    width: 47.56,
    height: 59.22,
    rx: 20.99
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1391.06,
    y: 210.05,
    width: 2.15,
    height: 15.04
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1400.7,227.39h-17.19a1.39,1.39,0,0,1,0-2.77h17.19a1.39,1.39,0,1,1,0,2.77"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1373.05,
    y1: 170.51,
    x2: 1382.6,
    y2: 170.51
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1373.05,
    y1: 173.95,
    x2: 1385.61,
    y2: 173.95
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1373.05,
    y1: 177.39,
    x2: 1381.89,
    y2: 177.39
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1410.11,
    y1: 170.88,
    x2: 1400.56,
    y2: 170.88
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1410.11,
    y1: 174.31,
    x2: 1397.55,
    y2: 174.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1410.11,
    y1: 177.75,
    x2: 1401.28,
    y2: 177.75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1387.62,
    y1: 151.41,
    x2: 1387.62,
    y2: 160.96
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1391.06,
    y1: 151.41,
    x2: 1391.06,
    y2: 163.97
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1394.49,
    y1: 151.41,
    x2: 1394.49,
    y2: 160.24
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 1367.8,
    y1: 191.92,
    x2: 1415.36,
    y2: 191.92
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1180.46,283.56s12.3,6.31,8.83-30.92h19.41L1207.28,279s-1,6.09-6.16,5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1185,283.56a4.53,4.53,0,1,1-4.52-4.52,4.52,4.52,0,0,1,4.52,4.52"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1205.58,284.43a4.62,4.62,0,1,1-4.61-4.61,4.61,4.61,0,0,1,4.61,4.61"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "1178.1 95.4 1178.1 113.31 1229.74 113.31 1229.74 39.76 1178.1 39.76 1178.1 62.98"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 1183.53,
    y1: 65.14,
    x2: 1210.39,
    y2: 65.14
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 1190.89,
    y1: 74.39,
    x2: 1221.29,
    y2: 74.39
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 1184.67,
    y1: 93.29,
    x2: 1223.18,
    y2: 93.29
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 1191.18,
    y1: 83.84,
    x2: 1221,
    y2: 83.84
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 1175.7,
    cy: 79.57,
    r: 16.29
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1183.55 80.73 1171.63 73.85 1171.63 87.61 1183.55 80.73"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M350.51,73.38c8.48,1.46,12-.15,13.52-2.07.79-1,1.88-3.4,4-8.26,1.13-2.54,1.73-4.08,2.69-4.11s1.82,1.75,2.86,3.85c3.13,6.36,5.27,10.69,7.67,10.9,1.57.14,3.12-1.9,6.16-6,4.15-5.57,4.85-8.49,6.43-8.39s1.8,2.88,4.91,8.17c2.13,3.62,4.48,7.63,6.63,7.34,1.33-.18,1.61-1.87,4.76-7.52,3.35-6,4.21-6.2,4.63-6.14,1.17.18,1.88,2.82,2.94,6.76.72,2.67.88,4.25,2.29,5.34a5.2,5.2,0,0,0,2.83,1c5.73.55,15.3.85,16.13.87"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M993.1,43.66a3.83,3.83,0,1,1-3.83-3.83,3.83,3.83,0,0,1,3.83,3.83"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1007.43,43.66a3.84,3.84,0,1,1-3.84-3.83,3.84,3.84,0,0,1,3.84,3.83"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1021.75,43.66a3.84,3.84,0,1,1-3.83-3.83,3.84,3.84,0,0,1,3.83,3.83"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1021.1,32.27h-36a9.18,9.18,0,0,0-9.15,9.16v4.46A9.17,9.17,0,0,0,985.09,55h24a14,14,0,0,1,7,2.25,14.82,14.82,0,0,1,6.15,9.74,21.68,21.68,0,0,0,1.61-5.14c.51-2.86.15-4.3,1.34-5.86.94-1.24,1.79-1.16,2.87-2.09,1.29-1.11,2.51-3.29,2.2-8V41.43A9.18,9.18,0,0,0,1021.1,32.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastplanningproduction6);
export default __webpack_public_path__ + "static/media/podcast planning & production6.cf2e333a24d1b20bf75ca57a5eaf740d.svg";
export { ForwardRef as ReactComponent };